export const SAVE_SELECTED = 'SAVE_SELECTED';
export const GET_SELECTED = 'GET_SELECTED';
export const RESET_CONFIGURATOR = 'RESET_CONFIGURATOR';
export const PUSH_RESULT = 'PUSH_RESULT';
export const INIT_STATE = 'INIT_STATE';
export const INIT_DATA = 'INIT_DATA';
export const SET_SCROLL_INDICATOR = 'SET_SCROLL_INDICATOR';
export const SET_LAST_QUESTION_ID = 'SET_LAST_QUESTION_ID';


// WEBPACK FOOTER //
// ./src/constants/actionTypes.js